import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Note } from "./records";

const slice = createEntitySlice<Note>({ name: "roomNotes" });

export const reducer = slice.reducer;
export const actions = slice.actions;
